import React from "react";
import Img from "gatsby-image";

export default ({headerImage}) => (
  <div className="header-image-wrapper">
    <Img
      className="header-image"
      sizes={headerImage.childImageSharp.sizes}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/HeaderImage/HeaderImage.jsx